import { useEffect } from "react";
import {
  checkForUpdates,
  isUpdateAvailable,
  updateAppVersion,
  clearServiceWorkerCache,
  checkPWAUpdate,
  registerPWAUpdateHandler,
} from "../../utils/cacheManager";

const CacheInvalidator = () => {
  useEffect(() => {
    // Register PWA update handler
    registerPWAUpdateHandler();

    const checkVersion = async () => {
      try {
        const latestVersion = await checkForUpdates();

        if (!latestVersion) {
          console.error("Failed to fetch build version");
          return;
        }

        const currentVersion = localStorage.getItem("build-version");

        // Convert both versions to the same type for comparison
        const normalizedLatest = String(latestVersion);
        const normalizedCurrent = String(currentVersion);

        if (currentVersion && normalizedLatest !== normalizedCurrent) {
          console.log("🔄 New version detected:", latestVersion, "vs", currentVersion);

          // Update the stored version
          updateAppVersion(latestVersion);

          // Clear service worker cache
          clearServiceWorkerCache();

          // Automatically reload to get the new version
          setTimeout(() => {
            window.location.reload(true);
          }, 1000);
        } else if (!currentVersion) {
          updateAppVersion(latestVersion);
        }
      } catch (err) {
        console.error("Failed to check app version", err);
        // Set a default version if the check fails
        if (!localStorage.getItem("build-version")) {
          localStorage.setItem("build-version", "1.0.0");
        }
      }
    };

    // Check version immediately
    checkVersion();

    // Check for updates every 5 minutes
    const interval = setInterval(checkVersion, 5 * 60 * 1000);

    // Also check for PWA updates
    const pwaInterval = setInterval(checkPWAUpdate, 30 * 1000); // Every 30 seconds

    return () => {
      clearInterval(interval);
      clearInterval(pwaInterval);
    };
  }, []);

  return null;
};

export default CacheInvalidator;
